import moment from 'moment-timezone';

import { dateRelativness } from './constants';

/**
 * Boolean predicates and comparators over timestamps.
 */

export const isToday = (date, timezone) => {
	const currentMoment = moment(new Date()).tz(timezone);
	const dateMoment = moment(date).tz(timezone);
	return currentMoment.isSame(dateMoment, 'day');
};

/**
 * Strictly-before comparison: true when `a` is before `b`. Wraps
 * `moment.isBefore` so callers don't have to import moment.
 */
export const isTimestampBefore = (a, b) => moment(a).isBefore(moment(b));

export const sortByDateUsingTimestamp = (timestampA, timestampB) => {
	const momentA = moment(timestampA).valueOf();
	const momentB = moment(timestampB).valueOf();
	return momentA - momentB;
};

export const isValidDate = (dateString) => {
	const date = new Date(dateString);
	return !isNaN(date.getTime());
};

/**
 * True when both timestamps fall on the same calendar day in the given
 * timezone. Timezone defaults to the browser's local (via `moment.tz.guess()`).
 * Pass an explicit IANA timezone (e.g. `'UTC'`, `'Europe/Berlin'`) when
 * the comparison must be deterministic across environments.
 */
export const areTheSameDates = (date1, date2, timezone = moment.tz.guess()) => {
	return moment.tz(date1, timezone).isSame(moment.tz(date2, timezone), 'day');
};

export const isDateInDaysArray = (date, daysArray, timezone) => {
	const dateMoment = moment(date).tz(timezone);
	return daysArray.some((day) => moment(day).tz(timezone).isSame(dateMoment, 'day'));
};

export const isTimeStampInPast = (timestampUtc) => {
	const inputTime = moment.utc(timestampUtc);
	const currentTime = moment.utc();
	return inputTime.isBefore(currentTime);
};

/**
 * Returns 'now' / 'past' / 'future' depending on where the timestamp sits
 * relative to the current moment. "now" is a ±30-second window.
 */
export const checkDateRelativeness = (timestamp, timezone = moment.tz.guess()) => {
	const timestampMoment = moment(timestamp).tz(timezone);
	const nowMoment = moment().tz(timezone);
	const diffSeconds = nowMoment.diff(timestampMoment, 'seconds');
	if (Math.abs(diffSeconds) <= 30) return dateRelativness.now;
	if (diffSeconds < 0) {
		return dateRelativness.future;
	} else {
		return dateRelativness.past;
	}
};
